import { Routes } from '@angular/router';
import { TranslationEditorResolver } from './pages/translation-editor/resolver/translation-editor.resolver';
import { ApplicationSettingsResolver } from './pages/application-settings/resolver/application-settings.resolver';
import { AuthGuard } from './core/guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'translation-editor',
    pathMatch: 'full',
  },
  {
    path: 'translation-editor',
    loadComponent: () => import('./pages/translation-editor/translation-editor.component').then(m => m.TranslationEditorComponent),
    resolve: {
      initialData: TranslationEditorResolver,
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'application-settings',
    loadComponent: () =>
      import('./pages/application-settings/application-settings.component').then(m => m.ApplicationSettingsComponent),
    resolve: {
      groups: ApplicationSettingsResolver,
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/add-application/add-application.component').then(m => m.AddApplicationComponent),
    data: {
      routeRoles: ['admin'],
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'no-access',
    loadComponent: () => import('./pages/no-access/no-access.component').then(m => m.NoAccessComponent),
    data: {
      routeRoles: ['nonDICMember'],
    },
    canActivate: [AuthGuard],
  },
];
